import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ENVIRONMENT} from '../../environments/environment';

import {AuthService} from './auth.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';


@Injectable()
export class PlatformMyInfoService {
  basePath: string;
  constructor(
    private _authService: AuthService,
    private _http: HttpClient,
  ) {
    this.basePath = `${window.location.origin}`;
  }

  private _generateRequestOptions(): Object {
    return {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${this._authService.getBearerToken()}`),
    };
  }

  getAuth(callBack: string): Observable<any> {
    const url = encodeURIComponent(this.basePath + callBack);
    return this._http.get(
      `${ENVIRONMENT.service.platform_my_info}/auth?is_redirect=false&callback_url=${url}`,
      this._generateRequestOptions(),
    );
  }

  getInformation(authCode): Observable<any> {
    const requestUrl = `${ENVIRONMENT.service.v2}/me/myinfo?auth_code=${authCode}`;
    return this._http.get(
      requestUrl,
      this._generateRequestOptions(),
    );
  }

  updateMember(data: any = {}): Observable<any> {
    const requestUrl = `${ENVIRONMENT.service.v2}/me/myinfo`;
    return this._http.put(
      requestUrl,
      data,
      this._generateRequestOptions(),
    );
  }

  getMyInfo() {
    return this._http.get(
      `${ENVIRONMENT.service.v2}/me`,
      this._generateRequestOptions(),
    ).pipe(
      map(({data}: any) => data.sg_gov_info ? data.sg_gov_info : null),
    );
  }
}
